import React from 'react';
import { Table } from '@duxton-web/ui';
import { Typography } from 'antd';
import { connect } from 'react-redux';

import { ExperimentFilters } from '../../../common/ExperimentFilters/ExperimentFiltersDock/IExperimentFilters';
import { ExperimentModel } from '../../../common/ExperimentModel';
import Service from '../../../lib/App';
import {
  ApprovalFlow,
  Experiment,
  ExperimentView,
  ExperimentViews,
  SuperExperiment,
} from '../../../lib/PlannerDTOs';
import { State } from '../../../store/state';
import {
  experimentModelsSelector,
  experimentsCollectionSelector,
} from '../../../store/state/experiments/selectors';
import { TIMESTAMP_FORMAT } from '../ExperimentDetailSubPage';
import {
  renderExperimentNameColumn,
  renderOwnerColumn,
  renderStatusColumn,
} from './DashboardColumn';

import './OverlapSummary.css';

interface OwnProps {
  experiment: Experiment;
}

interface StateProps {
  isFetching: boolean;
  experimentsStore: ExperimentModel[];
}

type OverlapProps = OwnProps & StateProps;

interface OverlapFlowState {
  isLoading: boolean;
  experiments: ExperimentModel[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  columns: {}[];
  data: string[];
}

const { Text } = Typography;

export class OverlapSummary extends React.Component<
  OverlapProps,
  OverlapFlowState
> {
  state = {
    isLoading: true,
    experiments: undefined,
    columns: undefined,
    data: undefined,
  };

  componentDidMount() {
    const experiment = this.props.experiment;
    if (!experiment.approvalFlow.resources) {
      this.setState({
        isLoading: false,
      });
      return;
    }
    const names = experiment.approvalFlow.resources;

    //populate columns
    this.getColumns();

    // check if store has our values
    const inStore =
      this.props.experimentsStore.filter((e) => {
        names.includes(e.name());
      }).length === names.length;

    if (inStore) {
      this.getData(experiment.approvalFlow, this.props.experimentsStore);
      this.setState({ isLoading: false });
    } else {
      //not in store, make api call
      this.loadOverlapExps(names).then(() => {
        this.getData(experiment.approvalFlow, this.state.experiments);
      });
    }
  }
  render() {
    if (!this.props.experiment.approvalFlow) {
      return <div />;
    }

    const data = this.state.data;
    const columns = this.state.columns;
    return (
      <div style={{ marginBottom: '16px', padding: '0 32px' }}>
        {data !== null && data?.length > 0 && (
          <div>
            <div className="overlapping-table-header">
              <Text strong style={{ fontSize: 15 }}>
                Overlapping Experiments
              </Text>
            </div>
            <Table
              size="large"
              style={{
                border: '1px solid #E8E8E8',
                background: '#FFFFFF',
                cursor: 'pointer',
                height: '100%',
              }}
              rowKey={(record) => record.name}
              rowClassName="exp-detail-table"
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={this.state.isLoading}
            />
          </div>
        )}
      </div>
    );
  }
  private loadOverlapExps = async (names: string[]): Promise<void> => {
    this.setState({ isLoading: true });
    let filters = {
      names: names,
    } as ExperimentFilters;
    try {
      const r: ExperimentViews = await Service.planner.fetchExperimentViews(
        {
          ...filters,
        },
        10,
        0,
      );
      const experiments: ExperimentModel[] = r.experiment_views.map(
        (e: ExperimentView): ExperimentModel =>
          new ExperimentModel(e.experiment_model),
      );
      this.setState({
        experiments: experiments,
        isLoading: false,
      });
    } catch (e) {
      const experiments = [];
      this.setState({
        isLoading: false,
        experiments: experiments,
      });
    }
  };

  private getColumns() {
    let columns = [
      {
        title: 'Experiment Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'Start Date',
        dataIndex: 'start',
        key: 'start',
      },
      {
        title: 'End Date',
        dataIndex: 'end',
        key: 'end',
      },
      {
        title: 'Approver',
        dataIndex: 'approver',
        key: 'approver',
      },
    ];
    this.setState({
      columns: columns,
    });
  }
  private getData(data: ApprovalFlow, exp: ExperimentModel[]) {
    const resources = data.resources;
    let rows = [];
    if (!resources || resources.length == 0) {
      return;
    }
    if (!exp || exp.length == 0) {
      return;
    }

    resources.forEach((resource) => {
      let currExp = exp.find((e) => e.name() === resource);
      if (currExp) {
        rows.push({
          key: resource,
          name: resource
            ? renderExperimentNameColumn(
                resource,
                currExp as unknown as SuperExperiment,
              )
            : 'nil',
          status: renderStatusColumn(currExp.state()),
          start: currExp.startDate().format(TIMESTAMP_FORMAT),
          end: currExp.endDate().format(TIMESTAMP_FORMAT),
          approver: renderOwnerColumn(currExp.owner()),
        });
      }
    });
    this.setState({
      data: rows,
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function mapStateToProps(state: State, props: OwnProps): StateProps {
  const experimentState = 'all';
  const { isFetching } = experimentsCollectionSelector(state, experimentState);
  return {
    isFetching,
    experimentsStore: experimentModelsSelector(state, experimentState),
  };
}

// eslint-disable-next-line @typescript-eslint/ban-types
export default connect<StateProps, {}, OwnProps, State>(mapStateToProps)(
  OverlapSummary,
);
